/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import React, { Component } from 'react';
import I from './input';
import isField from './isField';
import { Form } from 'semantic-ui-react';
import _ from '../../translations';

const Input = isField(I);
const Select = isField(Form.Select);

const styles = `
  .ui.input.share-url input {
    width: 100% !important;
  }

  .ui.input.share-url input:invalid {
    border: 1px solid red;
  }

  span.add-link {
    margin-left: 1rem;
    font-size: 10px;
    cursor: pointer;
  }

`;

const options = [
    {
        text: _('Share depending on app settings'),
        value: null,
    },
    {
        text: _('Always allow sharing'),
        value: true,
    },
    {
        text: _('Never allow sharing'),
        value: false,
    },
];

class Sharing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hidden: true,
        };
    }

    render() {
        const { hidden } = this.state;

        const { label = 'Social Sharing', name = 'shareable', shareUrlName = 'shareUrl', ...rest } = this.props;

        let { shareUrl } = this.props;

        if (shareUrl && shareUrl.length === 0) shareUrl = undefined;

        return (
            <React.Fragment>
                <style>{styles}</style>
                <Form.Field>
                    <label>
                        {_(label)}
                        <span onClick={() => this.setState({ hidden: !hidden })} className="add-link">
                            {_('Add Custom Link')}
                        </span>
                    </label>
                    <Select
                        placeholder={_('Sharing depending on app settings')}
                        defaultValue={null}
                        name={name}
                        {...rest}
                        options={options}
                    />
                </Form.Field>
                <Input
                    name={shareUrlName}
                    className="share-url"
                    placeholder="custom share link, ie: https://www.example.com (optional)"
                    defaultValue={shareUrl}
                    value={shareUrl}
                    style={{ display: shareUrl || !hidden ? 'initial' : 'none', width: '100%' }}
                    type="url"
                    pattern="https?://.+"
                />
            </React.Fragment>
        );
    }
}

export default Sharing;
